import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-tennis-green text-white text-center relative overflow-hidden" data-id="element-92">
      <div className="absolute inset-0 opacity-10 bg-[url('https://images.unsplash.com/photo-1595435934249-5df7ed86e1c0?q=40&w=1000&auto=format&fit=crop')] bg-cover bg-center mix-blend-overlay" data-id="element-93"></div>

      <div className="max-w-4xl mx-auto px-4 relative z-10" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-95">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-display leading-tight mb-10" data-id="element-96">
            El domingo podés seguir pensando qué dar mañana. O podés tenerlo
            todo resuelto en los próximos 5 minutos.
          </h2>

          <a href="#precio" className="inline-block w-full sm:w-auto bg-clay-orange hover:bg-clay-dark text-white font-display text-2xl py-6 px-12 rounded-2xl shadow-2xl hover:shadow-[0_20px_50px_rgba(217,116,65,0.4)] hover:-translate-y-2 transition-all duration-300 mb-10" data-id="element-97">
            🎾 QUIERO MI TENIS 360 AHORA →
          </a>

          <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10 text-sm text-gray-300 font-medium" data-id="element-98">
            <div className="flex items-center gap-2" data-id="element-99">
              <ShieldCheckIcon size={18} className="text-ball-yellow" data-id="element-100" />
              <span data-id="element-101">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-102">
              <LockIcon size={18} className="text-ball-yellow" data-id="element-103" />
              <span data-id="element-104">Pago seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-105">
              <ZapIcon size={18} className="text-ball-yellow" data-id="element-106" />
              <span data-id="element-107">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-108">
              <CreditCardIcon size={18} className="text-ball-yellow" data-id="element-109" />
              <span data-id="element-110">Tarjeta y transferencia</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}